import { Component, ElementRef, Host, HostListener, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { Align } from '@progress/kendo-angular-popup';
import { of } from 'rxjs';
import { ZoneCompany } from '../../auth/auth.models';
import { MasterviewComponent } from '../masterview.component';

@Component({
    selector: 'masterview-header',
    templateUrl: 'masterview.header.component.html',
    standalone: false
})
export class MasterviewHeaderComponent implements OnInit {	
	public companies: ZoneCompany[];
	public showFilter: boolean = false;

	public isUserProfileVisible: boolean = false;
	public userProfilePopupAlign: Align = { horizontal: "right", vertical: "top" };
	public userProfileAnchorAlign: Align = { horizontal: "right", vertical: "bottom" };

	public isHelpVisible: boolean = false;
	public helpPopupAlign: Align = { horizontal: "right", vertical: "top" };
	public helpAnchorAlign: Align = { horizontal: "right", vertical: "bottom" };

	public isRolesVisible: boolean = false;
	public rolesPopupAlign: Align = { horizontal: "right", vertical: "top" };
	public rolesAnchorAlign: Align = { horizontal: "right", vertical: "bottom" };

	public isCompanyListVisible: boolean = false;
	public companyPopupAlign: Align = { horizontal: "right", vertical: "top" };
	public companyAnchorAlign: Align = { horizontal: "right", vertical: "bottom" };

	public helpVideos: any[] = [];

	private lastPointerType = 'mouse';
	@HostListener('pointerdown', ['$event'])
	onPointerDown(event: PointerEvent) {
		this.lastPointerType = event.pointerType;
	}

	private companyListTimer: any;
	private companyListHideTimer: any;
	private isMouseOnCompanyListAnchor = false;
	private isMouseOnCompanyListPopup = false;
	showCompanyList() {
		if (this.companies !== this.parent.authService.user.companies) {
			this.companies = this.parent.authService.user.companies;
			this.showFilter = this.companies.length > 10;
		}
		this.isMouseOnCompanyListAnchor = true;
		clearTimeout(this.companyListHideTimer);
		clearTimeout(this.companyListTimer);
		this.companyListTimer = setTimeout(() => { this.isCompanyListVisible = true; }, 300);
	}
	hideCompanyList() {
		this.isMouseOnCompanyListAnchor = false;
		clearTimeout(this.companyListTimer);
		if (!this.isMouseOnCompanyListPopup) {
			this.companyListHideTimer = setTimeout(() => { this.isCompanyListVisible = false; }, 150);
		}
	}
	cancelHideCompanyList() {
		this.isMouseOnCompanyListPopup = true;
		clearTimeout(this.companyListHideTimer);
	}
	hideCompanyListFromPopup() {
		this.isMouseOnCompanyListPopup = false;
		if (!this.isMouseOnCompanyListAnchor) {
			this.companyListHideTimer = setTimeout(() => { this.isCompanyListVisible = false; }, 150);
		}
	}
	toggleCompanyList() {
		if (this.lastPointerType === 'mouse') return;
		if (this.isMouseOnCompanyListAnchor || this.isMouseOnCompanyListPopup) return;
		clearTimeout(this.companyListTimer);
		this.hideRoles();
		this.hideUserProfile();
		this.hideHelp();
		this.isCompanyListVisible = !this.isCompanyListVisible;
	}

	private rolesTimer: any;
	private rolesHideTimer: any;
	private isMouseOnRolesAnchor = false;
	private isMouseOnRolesPopup = false;
	showRoles() {
		this.isMouseOnRolesAnchor = true;
		clearTimeout(this.rolesHideTimer);
		clearTimeout(this.rolesTimer);
		this.rolesTimer = setTimeout(() => { this.isRolesVisible = true; }, 500);
	}
	hideRoles() {
		this.isMouseOnRolesAnchor = false;
		clearTimeout(this.rolesTimer);
		if (!this.isMouseOnRolesPopup) {
			this.rolesHideTimer = setTimeout(() => { this.isRolesVisible = false; }, 150);
		}
	}
	cancelHideRoles() {
		this.isMouseOnRolesPopup = true;
		clearTimeout(this.rolesHideTimer);
	}
	hideRolesFromPopup() {
		this.isMouseOnRolesPopup = false;
		if (!this.isMouseOnRolesAnchor) {
			this.rolesHideTimer = setTimeout(() => { this.isRolesVisible = false; }, 150);
		}
	}
	toggleRoles() {
		if (this.lastPointerType === 'mouse') return;
		if (this.isMouseOnRolesAnchor || this.isMouseOnRolesPopup) return;
		clearTimeout(this.rolesTimer);
		this.hideCompanyList();
		this.hideUserProfile();
		this.hideHelp();
		this.isRolesVisible = !this.isRolesVisible;
	}

	private userProfileTimer: any;
	private userProfileHideTimer: any;
	private isMouseOnUserProfileAnchor = false;
	private isMouseOnUserProfilePopup = false;
	showUserProfile() {
		this.isMouseOnUserProfileAnchor = true;
		clearTimeout(this.userProfileHideTimer);
		clearTimeout(this.userProfileTimer);
		this.userProfileTimer = setTimeout(() => { this.isUserProfileVisible = true; }, 500);
	}
	hideUserProfile() {
		this.isMouseOnUserProfileAnchor = false;
		clearTimeout(this.userProfileTimer);
		if (!this.isMouseOnUserProfilePopup) {
			this.userProfileHideTimer = setTimeout(() => { this.isUserProfileVisible = false; }, 150);
		}
	}
	cancelHideUserProfile() {
		this.isMouseOnUserProfilePopup = true;
		clearTimeout(this.userProfileHideTimer);
	}
	hideUserProfileFromPopup() {
		this.isMouseOnUserProfilePopup = false;
		if (!this.isMouseOnUserProfileAnchor) {
			this.userProfileHideTimer = setTimeout(() => { this.isUserProfileVisible = false; }, 150);
		}
	}
	toggleUserProfile() {
		if (this.lastPointerType === 'mouse') return;
		if (this.isMouseOnUserProfileAnchor || this.isMouseOnUserProfilePopup) return;
		clearTimeout(this.userProfileTimer);
		this.hideCompanyList();
		this.hideRoles();
		this.hideHelp();
		this.isUserProfileVisible = !this.isUserProfileVisible;
	}

	private helpTimer: any;
	private helpHideTimer: any;
	private isMouseOnHelpAnchor = false;
	private isMouseOnHelpPopup = false;
	showHelp() {
		this.isMouseOnHelpAnchor = true;
		clearTimeout(this.helpHideTimer);
		clearTimeout(this.helpTimer);
		this.helpTimer = setTimeout(() => { this.isHelpVisible = true; }, 500);
	}
	hideHelp() {
		this.isMouseOnHelpAnchor = false;
		clearTimeout(this.helpTimer);
		if (!this.isMouseOnHelpPopup) {
			this.helpHideTimer = setTimeout(() => { this.isHelpVisible = false; }, 150);
		}
	}
	cancelHideHelp() {
		this.isMouseOnHelpPopup = true;
		clearTimeout(this.helpHideTimer);
	}
	hideHelpFromPopup() {
		this.isMouseOnHelpPopup = false;
		if (!this.isMouseOnHelpAnchor) {
			this.helpHideTimer = setTimeout(() => { this.isHelpVisible = false; }, 150);
		}
	}
	toggleHelp() {
		if (this.lastPointerType === 'mouse') return;
		if (this.isMouseOnHelpAnchor || this.isMouseOnHelpPopup) return;
		clearTimeout(this.helpTimer);
		this.hideCompanyList();
		this.hideRoles();
		this.hideUserProfile();
		this.isHelpVisible = !this.isHelpVisible;
	}

	@ViewChild('filterInput') filterInput: any;
	@ViewChild('clientsMenu') clientsMenu: any;
	@ViewChild("userProfileAnchor") public userProfileAnchor: ElementRef;
	@ViewChild("helpAnchor") public helpAnchor: ElementRef;
	@ViewChild("rolesAnchor") public rolesAnchor: ElementRef;
	@ViewChild("companyAnchor") public companyAnchor: ElementRef;

	// get & set for _companiesFilter
	private _companiesFilter: string;
	get companiesFilter(): string {
		return this._companiesFilter;
	}
	set companiesFilter(value: string) {
		this._companiesFilter = value;
		if (this._companiesFilter) {
			this.companies = this.parent.authService.user.companies.filter((c) => c.companyNameAI.toLowerCase().includes(this._companiesFilter.toLowerCase()) || c.fiscalNumber.includes(this._companiesFilter.toLowerCase()));
		} else {
			this.companies = this.parent.authService.user.companies;
		}
	}

	constructor(@Host() public parent: MasterviewComponent) {
		this.companies = this.parent.authService.user.companies;
		this.showFilter = this.companies.length > 10;
	}

	ngOnInit() {}

	public onShowCompaniesMenu() {
		if(this.companies !== this.parent.authService.user.companies) {
		  // after adding a company sometimes masterview initializes before reload of companies occur
		  this.companies = this.parent.authService.user.companies;
		}
	
		if (this.filterInput) {
			this.filterInput.nativeElement.focus();
		}
	}

	public onHideCompaniesMenu() {
		this.companiesFilter = null;
	}

	public onInputClick($event: any) {
		$event.preventDefault();
		$event.stopImmediatePropagation();
		$event.stopPropagation();
	}

	public onInputKeyDown(e: any) {
		const self = this;
		if (e.keyCode === 13 && self.companies.length) {
			self.selectCompany(self.companies[0].externalId);
			self.clientsMenu.hide();
		}
	}

	public async selectCompany(companyId: string): Promise<void> {
		this.parent.makeSpecificMenuActive();
		this.parent.initLazy();

		await this.parent.selectCompanyId(companyId);
		this.companiesFilter = null;

		if (this.parent.isClient) {
			if (this.parent.isAccountSuspended()) {
				this.parent.goToContractPage();
			}
			else {
				this.parent.router.navigate(['/clients']);
			}
		}
    return of<void>().toPromise();
	}

	public get helpVideosAreVisible() {
		return !!(this.parent.helpConfig.videos);
	}

	public onShowVideosValueChange(event: any) {
		this.parent.authService.user.showHelp = !this.parent.authService.user.showHelp;
		this.parent.authService.updateMyData()
			.pipe(take(1))
			.subscribe();
	}

	public freshDesk() {
		this.parent.commonService.freshdeskUrlStream()
			.pipe(take(1))
			.subscribe((url: string) => {
				if (url && (url.startsWith('https://') || url.startsWith('http://'))) {
					window.open(url, '_blank', 'noopener noreferrer');
				}
			});
	}

	public gotoProfile(): void {
		this.parent.gotoProfile();
		this.isUserProfileVisible = false;
	}

	public gotoContact(): void {
		this.parent.gotoContact();
		this.isUserProfileVisible = false;
	}

	public get displayZones(): { code: string; displayName: string; }[] {
		const zones: { code: string; displayName: string; }[] = [];
		if (this.parent.authService.isInZone(this.parent.PredefinedUserZone.Administrator)) {
			zones.push({ code: this.parent.PredefinedUserZone.Administrator, displayName: this.parent.authService.getZoneDisplayName(this.parent.PredefinedUserZone.Administrator) });
		}
		if (this.parent.authService.isInZone(this.parent.PredefinedUserZone.Expert)) {
			zones.push({ code: this.parent.PredefinedUserZone.Expert, displayName: this.parent.authService.getZoneDisplayName(this.parent.PredefinedUserZone.Expert) });
		}
		if (this.parent.authService.isInZone(this.parent.PredefinedUserZone.HrExpert)) {
			zones.push({ code: this.parent.PredefinedUserZone.HrExpert, displayName: this.parent.authService.getZoneDisplayName(this.parent.PredefinedUserZone.HrExpert) });
		}
		if (this.parent.authService.isInZone(this.parent.PredefinedUserZone.Subcontractor)) {
			zones.push({ code: this.parent.PredefinedUserZone.Subcontractor, displayName: this.parent.authService.getZoneDisplayName(this.parent.PredefinedUserZone.Subcontractor) });
		}
		return zones;
	}

	public onZoneClick(zoneCode: string): void {
		this.parent.switchZone(zoneCode as any);
		this.isRolesVisible = false;
	}

	public onAvatarError(event: any) {
		event.target.onerror = '';
		const src: string = event.target.src;
		if (!src || !src.endsWith('/public/images/user-image.png')) {
			event.target.src = '/public/images/user-image.png';
		}
	}

	public onCompanySelect(companyId: string): void {
		this.selectCompany(companyId);
		this.isCompanyListVisible = false;
	}

	public openHelpMenuEditor() {
		this.parent.openHelpMenuEditor();
	}

	public closeHelpMenuEditor() {
		this.parent.closeHelpMenuEditor();
	}

	public openHelpVideoEditor() {
		this.parent.openHelpVideoEditor();
	}

	public closeHelpVideoEditor() {
		this.parent.closeHelpVideoEditor();
	}

}